/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const TableIcon = /*#__PURE__*/ createSvgIcon(
  'TableIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M3 15.5v-11c0-.412.147-.766.44-1.06.294-.293.648-.44 1.06-.44h11c.412 0 .766.147 1.06.44.293.294.44.648.44 1.06v11c0 .412-.147.766-.44 1.06-.294.293-.647.44-1.06.44h-11c-.412 0-.766-.147-1.06-.44A1.445 1.445 0 013 15.5zm1.5-8.063h11V4.5h-11v2.938zm4.167 4.042h2.666V8.938H8.667v2.541zm0 4.021h2.666v-2.52H8.667v2.52zM4.5 11.48h2.667V8.936H4.5v2.542zm8.333 0H15.5V8.936h-2.667v2.542zM4.5 15.5h2.667v-2.52H4.5v2.52zm8.333 0H15.5v-2.52h-2.667v2.52z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default TableIcon;
